/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface CaseProposal
 */
export interface CaseProposal {
    /**
     * 
     * @type {string}
     * @memberof CaseProposal
     */
    proposalName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseProposal
     */
    profile?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseProposal
     */
    investment?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseProposal
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseProposal
     */
    bookingCenter?: string;
    /**
     * 
     * @type {Array<Document>}
     * @memberof CaseProposal
     */
    documents?: Array<Document>;
}

/**
 * Check if a given object implements the CaseProposal interface.
 */
export function instanceOfCaseProposal(value: object): value is CaseProposal {
    return true;
}

export function CaseProposalFromJSON(json: any): CaseProposal {
    return CaseProposalFromJSONTyped(json, false);
}

export function CaseProposalFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseProposal {
    if (json == null) {
        return json;
    }
    return {
        
        'proposalName': json['proposalName'] == null ? undefined : json['proposalName'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'investment': json['investment'] == null ? undefined : json['investment'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'bookingCenter': json['bookingCenter'] == null ? undefined : json['bookingCenter'],
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentFromJSON)),
    };
}

export function CaseProposalToJSON(json: any): CaseProposal {
    return CaseProposalToJSONTyped(json, false);
}

export function CaseProposalToJSONTyped(value?: CaseProposal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proposalName': value['proposalName'],
        'profile': value['profile'],
        'investment': value['investment'],
        'currency': value['currency'],
        'bookingCenter': value['bookingCenter'],
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentToJSON)),
    };
}

